<template>
  <vxe-card>
    <div slot="title">
      <vxe-button content="menu.directionMaintain" mode="text" status="primary"/>
    </div>
    <vxe-table
      border
      stripe
      round
      show-overflow
      show-header-overflow
      :export-config="{}"
      ref="table"
      align="center"
      :data="data"
      :loading="loading"
      :keyboard-config="{isArrow: true}"
      :scroll-x="{enabled: true}"
      :column-config="{resizable:true}"
      size="mini"
      :row-config="{isCurrent: true, isHover: true}"
      :edit-config="{ trigger: 'click', mode: 'cell', showStatus: true }"
      keep-source
      :edit-rules="editRules">
      <vxe-column fixed="left" type="seq" width="40"/>
      <vxe-column :edit-render="{name:'VxeInput',autoSelect:true}" field="dayOfWeek" title="business.label.dayOfWeek" width="150"/>
      <vxe-column :edit-render="{name:'VxeInput',autoSelect:true}" field="ordinal" title="business.label.ordinal" width="300"/>
      <vxe-column fixed="right" title="business.label.operate" width="auto">
        <vxe-button-group slot-scope="{row}" mode="text">
          <vxe-button :disabled="row.id!==undefined" content="button.delete" icon="vxe-icon-delete" status="danger" @click.stop="remove(row)"/>
        </vxe-button-group>
      </vxe-column>
    </vxe-table>
    <div slot="extra">
      <vxe-button content="button.refresh" icon="vxe-icon-refresh" mode="text" status="primary" @click="refresh"/>
      <vxe-button content="button.add" icon="vxe-icon-add" mode="text" status="primary" @click="add"/>
      <vxe-button content="button.save" icon="vxe-icon-save" mode="text" status="primary" @click="save"/>
    </div>
  </vxe-card>
</template>

<script>
import { findAll, saveAll } from '@/api/Api'
import { Dictionary } from '@/api/dto/admin/Dictionary'
import { DirectionConfig } from '@/api/dto/config/DirectionConfig'

export default {
  name: 'DirectionConfig',
  components: { DirectionConfigTable: DirectionConfig },
  data() {
    return {
      loading: false,
      direction: new Dictionary(),
      data: [],
      editRules: {
        dayOfWeek: [
          { required: true, type: 'number', min: 1, message: '周几不能为空' }
        ],
        ordinal: [
          { required: true, type: 'number', min: 1, message: '序号不能为空' }
        ]
      }
    }
  },
  methods: {
    refresh() {
      this.loading = true
      findAll('directionConfigFactory', { 'direction.id': this.direction.id }).then(res => {
        if (res.success) {
          this.data = res.result.map(item => {
            return new DirectionConfig(item)
          })
        }
      }).finally(() => this.loading = false)
    },
    add() {
      this.data.push(new DirectionConfig())
    },
    remove(row) {
      this.loading = true
      if (!row.id) {
        this.data.splice(this.data.indexOf(row), 1)
      }
      this.loading = false
    },
    async save() {
      const errMap = await this.$refs.table.validate(true)
      if (errMap) {
        return
      }
      let saveData = this.$refs.table.getUpdateRecords().concat(this.$refs.table.getInsertRecords())
      if (saveData.length > 0) {
        this.loading = true
        saveData = saveData.map(item => {
          item.direction = this.direction
          return item.toJSONObject()
        })
        saveAll('directionConfigPersister', saveData).then(res => {
          if (res.success) {
            this.$message.success('保存成功')
            this.refresh()
          }
        }).finally(() => this.loading = false)
      } else {
        this.$message.warning('无数据可保存')
      }
    }
  }
}
</script>